import { useRef } from 'react';

let counter = 0;

const useUniqueId = (prefix = 'sso') => {
    const ref = useRef(null);
    if (ref.current === null) {
        counter += 1;
        ref.current = `${prefix}-${counter}`;
    }
    return ref.current;
};

export default useUniqueId;
